import EditIcon from "@/assets/icons/EditIcon";
import NewsFeedItemForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/NewsFeedItemForm";
import { TemplateDataSchemaType } from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/templateDataSchema";
import { Heading, Paragraph } from "@/components/ui/Typography";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import { Trash2Icon } from "lucide-react";
import { useState } from "react";
import { sanitizeHtml } from "@/utils/helpers/html";

const NewsItem = ({data, itemIndex}:{data: TemplateDataSchemaType["newsFeedSection"]["newsFeedSectionDetails"][0]; itemIndex: number}) => {

  const [isEditing, setIsEditing] = useState(false);
    const { templatePayload:templateData, updateTemplatePayload } = useMicroSiteContext();
    const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';
        const [showDeleteIcon, setShowDeleteIcon] = useState(false);

  const PreviewComponent = () => {
    return (
      <div className="grid relative lg:grid-cols-[1fr_2fr] gap-2 w-full  lg:gap-4  justify-center" onMouseEnter={() => setShowDeleteIcon(true)} onMouseLeave={() => setShowDeleteIcon(false)}>   

      {/* Delete Icon */}
{showDeleteIcon && isEdit &&  <div className="absolute p-1 bg-[rgba(255,255,255,0.8)] top-2 left-2 flex items-center justify-center rounded  z-10 cursor-pointer">
  <Trash2Icon color="red" onClick={() => {
    const updatedDetails = templateData.newsFeedSection?.newsFeedSectionDetails?.filter((_, index) => index !== itemIndex
    ) || [];
    const updatedPayload = {
      ...templateData,
      newsFeedSection: {
        ...templateData.newsFeedSection,
        newsFeedSectionDetails: updatedDetails
      }
    };
    updateTemplatePayload(updatedPayload);
  }} /> 
  </div>}

      <div>
         <img src={data.newsFeedSectionImageUrl ? data.newsFeedSectionImageUrl : "/blank-image-placeholder.png"} alt={data.newsFeedSectionTitle} className="max-h-96 h-full w-full object-cover object-center rounded" />
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-3">
           <Heading level={4}>{data.newsFeedSectionTitle}</Heading>
{isEdit && <EditIcon  className="cursor-pointer" width={48} onClick={() => setIsEditing(true)} />}
          </div>
         
          <Paragraph dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.newsFeedSectionDescription ?? "") }} ></Paragraph>
      </div>
      </div>
    )
  };


  return (
    <div>
      {isEditing ? <NewsFeedItemForm setIsEditing={setIsEditing} newsFeedData={data} /> : <PreviewComponent />}
    </div>
  )
}

export default NewsItem